// React decide si se puede abandonar el borrador; Angular conserva el destino.
export function registerBookingNavigationGuard(scope, state, guard) {
    let active = true;
    let pending = false;
    const unsubscribe = scope.$on(
        '$stateChangeStart',
        (event, toState, toParams, _fromState, _fromParams, options) => {
            if (event.defaultPrevented) return;
            if (pending) {
                event.preventDefault();
                return;
            }

            const decision = guard();
            if (decision === true) return;
            event.preventDefault();
            if (decision === false) return;

            pending = true;
            Promise.resolve(decision).then(
                (allowed) => {
                    pending = false;
                    if (!active || !allowed) return;
                    scope.$evalAsync(() => {
                        if (active) state.go(toState, toParams, options);
                    });
                },
                () => {
                    pending = false;
                },
            );
        },
    );

    return () => {
        active = false;
        unsubscribe();
    };
}
